module.exports = __webpack_public_path__ + "img/icon_bg3.16f13d0c.png";